module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    },
    model: {
      value: (_vm.filterPanel),
      callback: function($$v) {
        _vm.filterPanel = $$v
      },
      expression: "filterPanel"
    }
  }, [_c('v-expansion-panel-content', {
    key: "filterPanel",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Server Side Filters")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', [_c('p', [_vm._v("When filtering server side, filters need to be an exact match.")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Limit Results",
      "items": [
        50,
        100,
        250,
        500,
        1000
      ]
    },
    model: {
      value: (_vm.limit),
      callback: function($$v) {
        _vm.limit = $$v
      },
      expression: "limit"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Customer",
      "items": _vm.customerList,
      "item-value": "key",
      "item-text": "name",
      "clearable": ""
    },
    model: {
      value: (_vm.customer),
      callback: function($$v) {
        _vm.customer = $$v
      },
      expression: "customer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "User"
    },
    model: {
      value: (_vm.user),
      callback: function($$v) {
        _vm.user = $$v
      },
      expression: "user"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Job No"
    },
    model: {
      value: (_vm.jobNo),
      callback: function($$v) {
        _vm.jobNo = $$v
      },
      expression: "jobNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Project ID"
    },
    model: {
      value: (_vm.projectId),
      callback: function($$v) {
        _vm.projectId = $$v
      },
      expression: "projectId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Start",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.startDate),
            callback: function($$v) {
              _vm.startDate = $$v
            },
            expression: "startDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.startDateMenu),
      callback: function($$v) {
        _vm.startDateMenu = $$v
      },
      expression: "startDateMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.startDateMenu = false
      }
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Start Time",
      "mask": "time"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "End",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.endDate),
            callback: function($$v) {
              _vm.endDate = $$v
            },
            expression: "endDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.endDateMenu),
      callback: function($$v) {
        _vm.endDateMenu = $$v
      },
      expression: "endDateMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.endDateMenu = false
      }
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "End Time",
      "mask": "time"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": ""
    },
    on: {
      "click": _vm.applyFilters
    }
  }, [_vm._v("\n                  Apply Filters\n                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n      Audit Log\n      "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.auditData,
      "search": _vm.search,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(_vm._f("formatDateTime")(props.item.time)))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-transform": "capitalize"
          }
        }, [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.projectId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.jobNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.customer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.action))])]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('v-alert', {
          attrs: {
            "value": true,
            "color": "error",
            "icon": "warning"
          }
        }, [_vm._v("\n          Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n        ")])]
      },
      proxy: true
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27695c74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AuditLog.vue
// module id = 737
// module chunks = 1